import * as types from './mutation-types'

export default {
  [types.SET_CUSTOM_LISTS] (state, payload) {
    state.lists = payload.data
  },
  [types.SET_CUSTOM_LIST] (state, payload) {
    state.list = payload || {}
  },
  [types.SET_CUSTOM_LIST_ITEMS] (state, payload) {
    state.items = payload.data
    state.itemsPagination = {
      total: payload.total,
      current_page: payload.current_page,
      per_page: payload.per_page,
      last_page: payload.last_page
    }
  }
}
